import { ListModel, TranslationUDF } from "shared/interfaces/core-interfaces";
import * as yup from 'yup';

const nonWhitespaceRegExp = /^(?!<p>\s*<\/p>$).+/;

export interface TextblockTemplateModelForList {
    name: string;
    positionName: number;
    documentTypes: number;
    defaultText: string;
    defaultLanguage?: string | null;
    textTranslations: TranslationUDF[] | [];
}

export interface TextBlockToDocumentTypeResponse {
    name: string;
    documentType: number;
    isDefault: boolean;
    orderInDocument: number;
}

export interface TextBlockResponse {
    id: string;
    name: string;
    positionId: number;
    documentTypes: TextBlockToDocumentTypeResponse[] | [];
    defaultText: string;
    defaultLanguage?: string | null;
    textTranslations: TranslationUDF[] | []
}

export interface TextBlockResponseForDocuments {
    id: string;
    textBlockId?: string | null;
    name: string;
    positionId: number;
    positionName: string;
    orderInDocument: number;
    defaultText: string;
    defaultLanguage?: string | null;
    textTranslations?: TranslationUDF[] | null
    isDefault?: boolean;
}

export interface TextBlockForDocuments {
    id: string;
    textBlockId?: string | null;
    name: string;
    positionId: number;
    positionName: string;
    orderInPosition: number;
    defaultText: string;
    defaultLanguage?: string | null;
    textTranslations?: TranslationUDF[] | null
    isDefault?: boolean;
}

export interface ChangeTextblockTemplateModel {
    id: string
}

export interface TextBlockToDocumentTypeRequest {
    documentType: number;
    isDefault: boolean;
    orderInDocument: number | null;
}

export interface TextBlockRequest {
    id?: string;
    name: string;
    positionId: number;
    documentTypeIdsForFront: number[] | [];
    documentTypes: TextBlockToDocumentTypeRequest[];
    defaultText: string;
    defaultLanguage?: string | null;
    textTranslations?: TranslationUDF[] | null;
}

export interface TextblockTemplatesDropdownLists {
    positions: ListModel<number>[] | [],
    documentTypes: ListModel<number>[] | [],
    languages: ListModel<string>[] | []
}

export interface TextblockTemplateSliceModel {
    statusCode: string,
    isLoading: boolean,
    isModalLoading: boolean,
    message: string,
    showNotification: boolean,
    listOfActiveTemplates: TextblockTemplateModelForList[] | [],
    listOfInactiveTemplates: TextblockTemplateModelForList[] | [],
    listOfTextblocksByType: TextBlockResponseForDocuments[] | [],
    dropdownLists: TextblockTemplatesDropdownLists | null,
    template: TextBlockResponse | null
}

export const TranslationUDFScheme = yup.object().shape({
    language: yup.string().defined(),
    translation: yup.string().defined(),
})

export const TextblockModelScheme = yup.object().shape({
    id: yup.string(),
    name: yup.string().required("Name is required.").trim(),
    positionId: yup.number().typeError("Position on document is required.").required("Position on document is required.").positive("Position on document is required."),
    documentTypeIdsForFront: yup.array().min(1, "At least one document type must be selected.").required("Document type is required."),
    defaultText: yup.string()
        .required("Text (English) is required.")
        .notOneOf(["<p><br></p>"], "Text (English) is required.")
        .matches(nonWhitespaceRegExp, "Text (English) is required.")
        .default(""),
    textTranslations: yup.array().min(0, '').of(TranslationUDFScheme).nullable(),
    documentTypes: yup.array().defined()
})